import { create, test, enforce } from 'vest';

export const validate = create('stories', (data) => {
    test('name', 'Title is required.', () => {
        enforce(data.name)
            .isNotEmpty();
    });

    test('description', 'Description is required.', () => {
        enforce(data.description)
            .isNotEmpty();
    });
});
